<main class="bg-body">
  @if (loggedin) {
    <div class="row col-12 m-0 h-100">
      <app-sidebar id="sidemenu" class="col-1 h-100 border-right p-0 bg-body-tertiary overflow-y-auto overflow-x-hidden"></app-sidebar>
      <div class="col h-100 p-0 m-0 overflow-hidden d-flex flex-column">
        <app-navbar id="topnav" class="w-100"></app-navbar>
        <div id="content" class="p-4 focus-hidden"><router-outlet/></div>
      </div>
    </div>
  }

  @if (!loggedin && !loading) {
    <router-outlet/>
  }
  @if (loading) {
    <div class="loader d-flex align-items-center justify-content-center">
      <div class="card loading-card rounded-4 shadow-lg w-fit-content m-5 align-items-center">
        <div class="spinner-border text-primary align-item-center" style="width: 5rem; height: 5rem;" role="status"></div>
      </div>
    </div>
  }
</main>

<div class="toast-container position-fixed top-0 end-0 p-3" id="toast-container">
  <div id="Toast" class="toast" [ngClass]="state.success?'text-bg-success':'text-bg-danger'" role="alert" aria-live="assertive" aria-atomic="true">
    <div class="toast-header">
      <span class="rounded-4 me-2" [ngClass]="state.success?'text-bg-success':'text-bg-danger'" style="width: 10px;height: 10px;"></span>
      <strong class="me-auto">{{state.toastTitle}}</strong>
      <small>{{ state.time | date:'shortTime' }}</small>
      <button type="button" class="btn-close" data-bs-dismiss="toast" aria-label="Close"></button>
    </div>
    @if (state.toastContent != '') {
      <div class="toast-body text-light">
        {{state.toastContent}}
      </div>
    }
  </div>
</div>